import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import BadgeStatus from "../../../common/BadgeStatus";
import AlertService from "../../../components/SweetAlert";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import { newFetch, PUT } from "../../../helpers/fetch";

const ClaimsLog = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [selectedClaims, setSelectedClaims] = useState([]);

  const handleCheckboxChange = (id, isChecked) => {
    if (isChecked) {
      setSelectedClaims((prev) => [...prev, id]);
    } else {
      setSelectedClaims((prev) => prev.filter((claimId) => claimId !== id));
    }
  };

  const handleBulkCancel = async () => {
    if (selectedClaims.length === 0) return;

    if (
      await AlertService.confirm(
        "",
        `${t("Are you sure you want to cancel")} ${selectedClaims.length} ${t(
          "claim"
        )}?`
      )
    ) {
      const response = await newFetch(PUT, "/associate/claims/bulk-cancel", {
        claimIds: selectedClaims,
      });

      if (response.success) {
        ToastUtil.success(t("Claim(s) cancelled successfully"));
        setSelectedClaims([]);
        props.updateState();
      } else {
        ToastUtil.error(response.message || `${t("Failed to cancel claims")}`);
      }
    }
  };

  // Helper function to check if claim is pending
  const isPending = (status) => {
    return status.toLowerCase().includes("pending");
  };

  return (
    <div className="table-responsive bg-white rounded shadow p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">{t("Submissions")}</h5>
        <button
          className="btn btn-dark"
          disabled={selectedClaims.length === 0}
          onClick={handleBulkCancel}
        >
          {t("Cancel Claim")}
        </button>
      </div>

      <hr className="my-2" />

      <table className="table table-borderless mb-0">
        <tbody>
          {props.claims.length > 0 ? (
            props.claims.map((claim, index) => (
              <tr key={index} className="align-middle border-bottom">
                <td className="align-middle">
                  {isPending(claim.status) && (
                    <div className="form-check">
                      <input
                        className="form-check-input position-static"
                        type="checkbox"
                        value={claim.id}
                        checked={selectedClaims.includes(claim.id)}
                        onChange={(e) =>
                          handleCheckboxChange(claim.id, e.target.checked)
                        }
                      />
                    </div>
                  )}
                </td>

                <td>
                  <button
                    className="btn btn-link p-0"
                    style={{
                      color: "#5156BE",
                    }}
                    onClick={() =>
                      history.push({
                        pathname: "/claimsupdate",
                        state: { claim },
                      })
                    }
                  >
                    {claim.id} -{" "}
                    {claim.claim_type_name === "Staff Purchase"
                      ? t("Staff Purchase")
                      : claim.claim_type_name === "Transportation"
                      ? t("Transportation")
                      : claim.claim_type_name}
                  </button>

                  <div className="text-muted small d-flex align-items-center">
                    <span>
                      {claim.date_of_receipt
                        ? (() => {
                            const [day, month, year] =
                              claim.date_of_receipt.split("/");
                            const date = new Date(`${year}-${month}-${day}`);
                            return isNaN(date)
                              ? "-"
                              : date
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                  .replace(/ /, ", ");
                          })()
                        : "-"}
                    </span>

                    <span className="ml-2">
                      <BadgeStatus status={claim.status} />
                    </span>
                  </div>
                </td>

                <td>
                  <div>
                    {claim.amount != null ? claim.amount.toFixed(2) : "0.00"}{" "}
                    {props.activeSite?.enable_claim_percentage && (
                      <span
                        style={{
                          color: "#5156BE",
                        }}
                      >
                        (
                        {claim.deduct_amount != null
                          ? claim.deduct_amount.toFixed(2)
                          : "0.00"}
                        )
                      </span>
                    )}
                  </div>
                  <div className="text-muted small">{t("Amount")}</div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center text-muted py-4">
                {t("No records found")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClaimsLog;
